import { Component, Inject, OnInit } from '@angular/core';
import { NX_MODAL_DATA } from '@aposin/ng-aquila/modal';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { SharedService } from 'src/app/shared/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-localstorage';

@Component({
  selector: 'app-consent-pop-up',
  templateUrl: './consent-pop-up.component.html',
  styleUrls: ['./consent-pop-up.component.scss']
})
export class ConsentPopUpComponent implements OnInit {
  trigger1: boolean = false;
  trigger2: any = false;
  flag;
  isBG:boolean


  constructor(
    public sharedService: SharedService,
    private translate:TranslateService,
    private storage: LocalStorageService,
    @Inject(NX_MODAL_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    this.flag=this.sharedService.getConsentsFlag();
    this.readMore(this.flag);
  }
  readMore(trigger) {
    if (trigger == 'B1') {
      this.trigger1 = !this.trigger1;
    }
    if (trigger == 'B2') {
      this.trigger2 = !this.trigger2;
    }
  }

}
